import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { CdkStepper, CdkStepperModule } from '@angular/cdk/stepper';
import { CommonModule, NgTemplateOutlet } from '@angular/common';
import { BookingPartStepperComponent } from '../booking-part/stepper/stepper.component';
import { ControlContainer, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import { BookingStepsFormType } from '@app/shared/models/booking-steps-form-type.model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-booking-stepper',
  templateUrl: './booking-stepper.smart.component.html',
  styleUrls: ['./booking-stepper.smart.component.scss'],
  standalone: true,
  providers: [{ provide: CdkStepper, useExisting: BookingStepperSmartComponent }],
  viewProviders: [{
    provide: ControlContainer,
    useExisting: FormGroupDirective
  }],
  imports: [
    CommonModule,
    CdkStepperModule,
    NgTemplateOutlet,
    BookingPartStepperComponent,
    ReactiveFormsModule
  ]
})

export class BookingStepperSmartComponent extends CdkStepper implements OnInit, OnDestroy {

  public readonly parentFormDirective = inject(FormGroupDirective);
  public parentForm: BookingStepsFormType;
  private readonly masterSubscription = new Subscription();

  ngOnInit(): void {
    this.parentForm = this.parentFormDirective.form;
    this.selectedIndex = this.parentForm.controls.activeStep.value;
    this.masterSubscription.add(this.selectionChange.subscribe((val) => {
      this.parentForm.controls.activeStep.setValue(val.selectedIndex);
    }));
  }

  ngOnDestroy(): void {
    this.masterSubscription.unsubscribe();
  }
}
